import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';

import { buttonClassName, ButtonTestID, CircularProgressTestID } from './constants';

export interface Props {
  className?: string;
  isDisabled?: boolean;
  isInProgress: boolean;
  onClick: () => void;
  text?: string;
}

const CancelSessionButton: React.FC<Props> = ({
  className,
  isDisabled = false,
  isInProgress,
  onClick,
  text = 'Cancel session',
}) => {
  const handleClick = () => {
    if (isInProgress || isDisabled) return;

    onClick();
  };

  return (
    <button
      className={classNames(buttonClassName, className, { 'cursor-not-allowed': isDisabled })}
      data-testid={ButtonTestID}
      onClick={handleClick}
      {...{ disabled: isDisabled }}
    >
      {isInProgress && (
        <CircularProgress
          data-testid={CircularProgressTestID}
          size={17}
          style={{
            color: '#424f60', // text-gray-700
          }}
        />
      )}

      {!isInProgress && text}
    </button>
  );
};

export default CancelSessionButton;
